import React from 'react';
import '../../../../assets/css/Modal.css'
import {
    Modal,
} from 'react-bootstrap';
import {toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment/moment";
import DatePicker, {registerLocale} from "react-datepicker";
import StudentController from "../../../../services/system/student/student-controller";
import vi from "date-fns/locale/vi";
import {getSchoolYear} from "../../../../utils/authority";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
registerLocale("vi", vi);
class ModalTransClass extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            reason: '',
            name: this.props.name,
            showBlock: true,
            chuyenLopDay: new Date(),
            lydoChuyenLop: "",
            listClass: [],
            giuThongTinLopCu: true,
        };
    }
    UNSAFE_componentWillReceiveProps(nextProps, nextContext){
        this.setState({
            name:  nextProps.name,
            studentId:  nextProps.id,
        }, ()=>{
            if (this.state.studentId != undefined){
                this.getDetailStudent(this.state.studentId)
            }
        })
    }
    getDetailStudent = (studentId) => {
        StudentController.detail(studentId, res => {
            let data = res.data
            if (res.success){
                this.setState({
                    gradeId:  data.grade,
                }, ()=>{
                    this.getListClass()
                })
            } else {
                toast.error("Đã xảy ra lỗi! " + res.message)
            }

        })
    };
    getListClass() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            name: "",
            pageNumber: 0,
            pageSize: 200,
            sort: "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                showLoading: false,
                listClass: res.data.content,
            });
        })
    }
    onTransClass = () => {
        let payload = {
            studentId: this.state.studentId,
            classIdTo: this.state.classIdTo,
            chuyenLopDay: this.state.chuyenLopDay,
            hocky: this.state.hocky,
            lydoChuyenLop: this.state.lydoChuyenLop,
            giuThongTinLopCu: this.state.giuThongTinLopCu,
        }
        StudentController.chuyenLop(payload, res => {
            if (res.success) {
                toast.success("Cập nhật chuyển lớp thành công!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
                this.props.onHide();
                this.props.onRefresh()
            } else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    }

    renderClass() {
        return this.state.listClass.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    render() {
        const modalProp = {
            show: this.props.show,
            onHideModal: this.props.onHide,
            keyboard: false,
            backdrop: 'static',
        };
        return (
            <div>
                <Modal {...modalProp} dialogClassName="modal-dialog-centered">
                    <div className="modal-container">
                        <div className="btn-close">
                            <button type="button" className="close" onClick={this.props.onHide}>
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                    </div>
                    <Modal.Body>
                        <div>
                            <h1 className="text-center" style={{fontSize: 20,}}><b>Cập nhật chuyển lớp-Học sinh {this.state.name} </b></h1>
                        </div>
                        <div className='d-flex justify-content-center mt-12 mb-12'>
                            <div className="row">
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Ngày chuyển lớp<span  style={{color: "red",}}>*</span></label>
                                    <DatePicker
                                        locale="vi"
                                        className="w-auto  form-control kt-input pd-4-input hei-input"
                                        selected={this.state.chuyenLopDay === '' ? null : new Date(this.state.chuyenLopDay)}
                                        minDate={new Date()}
                                        placeholderText="Chuyển chuyển trường"
                                        dateFormat="dd-MM-yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        onChange={
                                            (date) => {
                                                let value = moment(date).format("YYYY-MM-DD").toString();
                                                try {
                                                    this.setState({
                                                        chuyenLopDay: value == "Invalid date" ? null : moment(value).format("YYYY-MM-DD"),
                                                        inEditing: true
                                                    })
                                                }catch (e) {

                                                }
                                            }
                                        }
                                    />
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Học kỳ chuyển<span  style={{color: "red",}}>*</span></label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.hocky}
                                        onChange={(e) => {
                                            this.state.hocky = e.target.value;
                                            this.setState({
                                                hocky: e.target.value,
                                                inEditing: true
                                            })
                                        }}
                                    >
                                        <option value="0">Kỳ I</option>
                                        <option value="1">Kỳ II</option>
                                        <option value="2">Kỳ Hè</option>
                                    </select>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="label-item col-4">Lớp</label>
                                    <select
                                        className="form-control kt-input pd-4-input hei-input"
                                        value={this.state.classIdTo}
                                        onChange={(e) => {
                                            this.state.classIdTo = e.target.value;
                                            this.setState({
                                                classIdTo: e.target.value,
                                                inEditing: true
                                            })
                                        }}
                                    >
                                        <option value="">Tất cả</option>
                                        {this.renderClass()}
                                    </select>
                                </div>
                                <div className="col-12 d-flex mb-2">
                                    <label className="col-4 label-item pl-0">Lý do chuyển</label>
                                    <textarea name="lydoChuyenLop" id="" cols="30" rows="3"
                                              maxLength="255"
                                              className="form-control"
                                              value={this.state.lydoChuyenLop}
                                              onChange={e => this.setState({lydoChuyenLop: e.target.value})}/>
                                </div>
                                <div className="col-12 col-xs-12 d-flex mb-2">
                                    <label>
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                const value = this.state.giuThongTinLopCu;
                                                this.setState({giuThongTinLopCu: !value});
                                            }}
                                            checked={this.state.giuThongTinLopCu}
                                        />
                                        {' '}
                                        Giữ thông tin lớp cũ
                                    </label>
                                </div>
                            </div>
                        </div>


                        <div className=" align-right col-12">
                            <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s background-btn w-50 type-button-fix btn btn-primary"
                                    onClick={() => this.onTransClass()}
                                >
                                        <span className='d-flex justify-content-center'>
                                            Lưu
                                        </span>
                                </button>
                                <button
                                    type="button"
                                    className="ml-4 col-3 border-1-s w-50 type-button-fix btn btn-secondary"
                                    onClick={this.props.onHide}
                                >
                                        <span className='d-flex justify-content-center'>
                                            Hủy bỏ
                                        </span>
                                </button>
                            </div>
                        </div>

                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}
export default ModalTransClass
